export const UNIT_MAP: { [index: string]: any } = {
  mm: {
    label: 'inches',
    rate: 0.03937007874015748031,
  },
  'm/s': {
    label: 'mph',
    rate: 2.23693629,
  },
  'mm/h': {
    label: 'in/h',
    rate: 0.03937007874015748031,
  },
  l: {
    label: 'gallon',
    rate: 0.264172052,
  },
  kilolitres: {
    label: 'gallon',
    rate: 264.172052,
  },
  liters: {
    label: 'gallon',
    rate: 0.264172052,
  },
  m2: {
    label: 'ft2',
    rate: 10.7639,
  },
  'l/h': {
    label: 'gal/h',
    rate: 0.264172052,
  },
  'l/m': {
    label: 'gpm',
    rate: 0.264172052,
  },
  C: {
    label: 'F',
    rate: 9 / 5,
  },
  cm3: {
    label: 'in3',
    rate: 0.06102,
  },
  m3: {
    label: 'ft3',
    rate: 35.3147,
  },
  m: {
    label: 'ft',
    rate: 3.28084,
  },

  m3togallon: {
    label: 'gallon',
    rate: 264.172, // 1 m³ = 264.172 gallons
  },

  mtoin: {
    label: 'in',
    rate: 39.3701, // 1 m = 39.3701 inches
  },
}

export enum UNIT_MAP_V2_KEYS {
  M = 'm',
  MM = 'mm',
  M2 = 'm2',
  M3 = 'm3',
  L = 'l',
  KILOLITRES = 'kilolitres',
  M_S = 'm/s',
  L_H = 'l/h',
  L_M = 'l/m',
  MM_H = 'mm/h',
  C = 'C',
  IN = 'in',
  FT = 'ft',
  YD = 'yd',
  IN2 = 'in2',
  FT2 = 'ft2',
  GALLON = 'gallon',
  QUART = 'quart',
  GAL_H = 'gal/h',
  GPM = 'gpm',
  IN_H = 'in/h',
  F = 'F',
  FT3 = 'ft3',
  IN3 = 'in3',
  YD3 = 'yd3',
  GAL3 = 'gal3',
  QUART3 = 'quart3',
}
export const UNIT_MAP_V2: UnitMapV2Type = {
  m: {
    imperial: {
      ft: { label: 'ft', rate: 3.28084 },
      in: { label: 'in', rate: 39.3701 },
      yd: { label: 'yd', rate: 1.09361 },
    },
    defaultImperial: 'in',
  },
  mm: {
    imperial: {
      in: { label: 'in', rate: 0.03937007874015748031 },
    },
    defaultImperial: 'in',
  },
  m2: {
    imperial: {
      ft2: { label: 'ft²', rate: 10.7639 },
      in2: { label: 'in²', rate: 1550.0031 },
    },
    defaultImperial: 'ft2',
  },

  m3: {
    imperial: {
      ft3: { label: 'ft³', rate: 35.3147 },
      in3: { label: 'in³', rate: 61023.7 },
      gallon: { label: 'gal', rate: 264.172 },
    },
    defaultImperial: 'ft3',
  },

  l: {
    imperial: {
      gallon: { label: 'gal', rate: 0.264172052 },
      quart: { label: 'qt', rate: 1.05669 },
    },
    defaultImperial: 'gallon',
  },
  kilolitres: {
    imperial: {
      gallon: { label: 'gal', rate: 264.172052 },
      kilogallon: { label: 'kGal', rate: 0.264172 },
    },
    defaultImperial: 'gallon',
  },

  'm/s': {
    imperial: {
      mph: { label: 'mph', rate: 2.23693629 },
      'ft/s': { label: 'ft/s', rate: 3.28084 },
    },
    defaultImperial: 'mph',
  },

  'l/h': {
    imperial: {
      'gal/h': { label: 'gal/h', rate: 0.264172052 },
    },
    defaultImperial: 'gal/h',
  },
  'l/m': {
    imperial: {
      gpm: { label: 'gpm', rate: 0.264172052 },
    },
    defaultImperial: 'gpm',
  },

  'mm/h': {
    imperial: {
      'in/h': { label: 'in/h', rate: 0.03937007874015748031 },
    },
    defaultImperial: 'in/h',
  },

  C: {
    imperial: {
      F: {
        label: 'F',
        rate: 9 / 5,
        offset: 32,
      },
    },
    defaultImperial: 'F',
  },
}

export type ImperialUnit = {
  label: string
  rate: number
  offset?: number
}

export type UnitDefinition = {
  imperial: {
    [key: string]: ImperialUnit
  }
  defaultImperial: string
}

export type UnitMapV2Type = {
  [key: string]: UnitDefinition
}

export interface UnitConfig {
  metricLabel: string
  defaultImperial: string
  imperial: {
    [key: string]: {
      label: string
      rate: number
      offset?: number
    }
  }
}

export const NumberFractionDigits = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}
